import { render } from "./Provide.vue?vue&type=template&id=4f1768ae"
import script from "./Provide.vue?vue&type=script&lang=js"
export * from "./Provide.vue?vue&type=script&lang=js"

import "./Provide.vue?vue&type=style&index=0&id=4f1768ae&lang=css"
script.render = render

export default script